import SEO from "../../../../src/components/seo";
import Hero from "../../../../src/components/hero";
import { Link, graphql } from 'gatsby';
import Img from 'gatsby-image';
import BackgroundImage from 'gatsby-background-image';
import HomeSelector from "../../../../src/components/home-selector";
import React from 'react';
export default {
  SEO,
  Hero,
  Link,
  graphql,
  Img,
  BackgroundImage,
  HomeSelector,
  React
};